export interface FileUpload {
  fullPath: string;
  shortPath: string;
}
